import { ref, watch, onActivated } from 'vue'
import { getToConvertTask, getOtherTask, getCycleFollowTask } from '@/api/gucangSales/index'
import type { AnalysisType } from '@/types/index'
import dayjs from 'dayjs'

interface TaskData {
    title: string
    secondData:string|number
    firstData:string|number
  }
export default function taskSetting(formState:AnalysisType) {
  const followTask = ref<TaskData[]>()
  const readyChangeTask = ref<TaskData[]>()
  const otherTask = ref<TaskData[]>()
  const getOtherTaskList = async() => {
    try {
      const resOtherTask:any = await getOtherTask({
        depCode: formState.otherTask?.depCode,
        startDate: formState.otherTask?.startTime ? dayjs(formState.otherTask?.startTime).format('YYYY/MM/DD') : formState.otherTask?.startTime,
        endDate: formState.otherTask?.endTime ? dayjs(formState.otherTask?.endTime).format('YYYY/MM/DD') : formState.otherTask?.endTime

      })
      otherTask.value = [
        {
          title: '未来线索跟进任务',
          secondData: resOtherTask.data.clueFutureTotal,
          firstData: resOtherTask.data.clueFuture
        },
        {
          title: '访客计划',
          secondData: resOtherTask.data.visitPlanTotal,
          firstData: resOtherTask.data.visitPlan
        }
      ]
    } catch (error) {
      otherTask.value = [
        {
          title: '未来线索跟进任务',
          secondData: 0,
          firstData: 0
        },
        {
          title: '访客计划',
          secondData: 0,
          firstData: 0
        }
      ]
      console.log('error: ', error)
    }
  }
  const getToConvertTaskList = async() => {
    try {
      const res:any = await getToConvertTask({
        depCode: formState.toConvertTask?.depCode,
        month: dayjs(formState.toConvertTask?.month).format('YYYY/MM/DD')
      })

      readyChangeTask.value = [
        {
          title: '新线索',
          secondData: res.data.newClueNumTarget,
          firstData: res.data.newClueNum
        },
        {
          title: '新潜在客户',
          secondData: res.data.newPotentialCustomerNumTarget,
          firstData: res.data.newPotentialCustomerNum
        },
        {
          title: '新签约客户',
          secondData: res.data.newContractCustomerNumTarget,
          firstData: res.data.newContractCustomerNum
        },
        {
          title: '新成交客户',
          secondData: res.data.newDealCustomerNumTarget,
          firstData: res.data.newDealCustomerNum
        },
        {
          title: '老客户新商机额(万元)',
          secondData: res.data.oldDealCustomerNewAmountTarget,
          firstData: res.data.oldDealCustomerNewAmount
        }
      ]
    } catch (error) {
      console.log('error: ', error)
      readyChangeTask.value = [
        {
          title: '新线索',
          secondData: 0,
          firstData: 0
        },
        {
          title: '新潜在客户',
          secondData: 0,
          firstData: 0
        },
        {
          title: '新签约客户',
          secondData: 0,
          firstData: 0
        },
        {
          title: '新成交客户',
          secondData: 0,
          firstData: 0
        },
        {
          title: '老客户新商机额(万元)',
          secondData: 0,
          firstData: 0
        }
      ]
    }
  }
  const getCycleFollowTaskList = async() => {
    try {
      const resToConvertTask:any = await getCycleFollowTask({
        depCode: formState.cycleFollowTask?.depCode
      })
      followTask.value = [
        {
          title: '有效销售线索（首次）',
          secondData: resToConvertTask.data.saleClueFirstTotal,
          firstData: resToConvertTask.data.saleClueFirst
        },
        {
          title: '有效销售线索（循环）',
          secondData: resToConvertTask.data.saleClueCycleTotal,
          firstData: resToConvertTask.data.saleClueCycle
        },
        {
          title: '潜在客户（谈判）',
          secondData: resToConvertTask.data.potentialNegotiationTotal,
          firstData: resToConvertTask.data.potentialNegotiation
        },
        {
          title: '潜在客户（搁置）',
          secondData: resToConvertTask.data.potentialShelvedTotal,
          firstData: resToConvertTask.data.potentialShelved
        },
        {
          title: '签约客户（对接）',
          secondData: resToConvertTask.data.contractDockingTotal,
          firstData: resToConvertTask.data.contractDocking
        },
        {
          title: '签约客户（暂停合作）',
          secondData: resToConvertTask.data.contractPauseTotal,
          firstData: resToConvertTask.data.contractPause
        },
        {
          title: '成交客户（1档）',
          secondData: resToConvertTask.data.dealOneTotal,
          firstData: resToConvertTask.data.dealOne
        },
        {
          title: '成交客户（2档）',
          secondData: resToConvertTask.data.dealTwoTotal,
          firstData: resToConvertTask.data.dealTwo
        },
        {
          title: '成交客户（3档）',
          secondData: resToConvertTask.data.dealThreeTotal,
          firstData: resToConvertTask.data.dealThree
        },
        {
          title: '成交客户（4档）',
          secondData: resToConvertTask.data.dealFourTotal,
          firstData: resToConvertTask.data.dealFour
        }
      ]
    } catch (error) {
      followTask.value = [
        {
          title: '有效销售线索（首次）',
          secondData: 0,
          firstData: 0
        },
        {
          title: '有效销售线索（循环）',
          secondData: 0,
          firstData: 0
        },
        {
          title: '潜在客户（谈判）',
          secondData: 0,
          firstData: 0
        },
        {
          title: '潜在客户（搁置）',
          secondData: 0,
          firstData: 0
        },
        {
          title: '签约客户（对接）',
          secondData: 0,
          firstData: 0
        },
        {
          title: '签约客户（暂停合作）',
          secondData: 0,
          firstData: 0
        },
        {
          title: '成交客户（1档）',
          secondData: 0,
          firstData: 0
        },
        {
          title: '成交客户（2档）',
          secondData: 0,
          firstData: 0
        },
        {
          title: '成交客户（3档）',
          secondData: 0,
          firstData: 0
        },
        {
          title: '成交客户（4档）',
          secondData: 0,
          firstData: 0
        }
      ]

      console.log('error: ', error)
    }
  }
  watch(
    () => formState.cycleFollowTask,
    () => {
      getCycleFollowTaskList()
    },
    { deep: true, immediate: true }
  )
  watch(
    () => formState.toConvertTask,
    () => {
      getToConvertTaskList()
    },
    { deep: true, immediate: true }
  )
  watch(
    () => formState.otherTask,
    () => {
      getOtherTaskList()
    },
    { deep: true, immediate: true }
  )
  onActivated(() => {
    // getOtherTaskList()
    getToConvertTaskList()
    // getCycleFollowTaskList()
  })
  // onMounted(() => {
  //   getOtherTaskList()
  //   getCycleFollowTaskList()
  //   getToConvertTaskList()
  // })
  return { followTask, readyChangeTask, otherTask }
}
